<template>
    <v-col class="pa-0 pt-4" cols="12">
        <v-card class="flex pa-0 round-card background-2">
            <v-card-title class="pa-3">
                <p class="pl-2 pl-xl-3">Autenticatione a 2 fattori</p>
            </v-card-title>        
            <v-divider></v-divider>
            <template v-if="$store.getters.getProfile.twofa">
                <v-alert class="background-2">
                    <v-row align="center">
                        <v-col class="grow">
                            <v-subheader class="px-0">Disattiva l'autenticazione a 2 fattori</v-subheader>
                        </v-col>
                        <v-col class="shrink">
                            <v-btn class="mx-0" color="red" :loading="loading2FA" :disabled="startDisableTwoFactorAuthentication || $store.getters.checkSettings('2fa')" @click.stop="startDisableTwoFactorAuthentication = true">
                                Disattiva
                                <v-icon class="ml-4" color="white">mdi-two-factor-authentication</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-alert>
                <template v-if="startDisableTwoFactorAuthentication">
                    <div class="ma-auto position-relative" style="max-width: 300px">
                        <v-otp-input
                            length="6"
                            type="number"
                            v-model="otp"
                            :disabled="loadingOTP"
                            @finish="disableTwoFactorAuthentication()"
                        ></v-otp-input>
                    </div>					
                    <v-row class="ma-0 mb-4" align="center">
                        <p class="px-0 py-8 ma-auto">Per disattivare l'autenticazione a 2 Fattori inserisci per l'ultima volta il codice OTP</p>
                    </v-row>
                </template>
            </template>
            <template v-else>
                <v-alert class="background-2">
                    <v-row align="center">
                        <v-col class="grow">
                            <v-list-item-title>Autenticatione a 2 fattori</v-list-item-title>
                            <v-subheader class="px-0">Attiva l'autenticazione a 2 fattori e rendi GiveMeHive un posto più sicuro</v-subheader>
                        </v-col>
                        <v-col class="shrink">
                            <v-btn class="mx-0" color="success" :loading="loading2FA" :disabled="!!twofaqrcode" @click.stop="enableTwoFactorAuthentication()">
                                Attiva
                                <v-icon class="ml-4" color="white">mdi-two-factor-authentication</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-alert>
                <v-card class="flex pa-0 mb-4 round-card background-2" v-if="twofaqrcode">
                    <v-card-text>
                        <v-img
                            :src="twofaqrcode"
                            width="250"
                            class="ma-auto round-card"
                        ></v-img>	
                        <v-row class="ma-0" align="center">
                            <p class="px-0 pt-8 pb-2 ma-auto">Scansiona questo QR code con un'app di autenticazione a due fattori</p>
                        </v-row>
                        <v-row class="ma-0" align="center">
                            <p class="px-0 mb-8 ma-auto">Secret Key: {{ google2fa_secret }}
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">											
                                        <v-btn v-bind="attrs" v-on="on" class="mx-6"
                                            icon
                                            small
                                            @click.native.stop="getCopy()">
                                            <v-icon color="primary">mdi-content-copy</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Copia</span>
                                </v-tooltip>
                            </p>
                        </v-row>
                        <div class="ma-auto position-relative" style="max-width: 300px">
                            <v-otp-input
                                length="6"
                                type="number"
                                v-model="otp"
                                :disabled="loadingOTP"
                                @finish="verifyOTP()"
                            ></v-otp-input>
                        </div>
                    </v-card-text>
                </v-card>
            </template>
        </v-card>
    </v-col>  
</template>

<script>
    export default {
		name: 'profile-two-factor',
        data: () => ({
            loading2FA: false,
            twofaqrcode: '',
            google2fa_secret: '',
            otp: '',
            loadingOTP: false,
            startDisableTwoFactorAuthentication: false,
        }),
        methods: {
            enableTwoFactorAuthentication() {
				this.loading2FA = true
				this.axios.get('users-enable2fa').then((response) => {
					this.twofaqrcode = response.data.data.qrcode
					this.google2fa_secret = response.data.data.google2fa_secret

					this.loading2FA = false
				}).catch(error => {
					this.loading2FA = false
				})
			},

            disableTwoFactorAuthentication() {
				this.loading2FA = true

				this.axios.post('users-disable2fa', {otp: this.otp}).then((response) => {
					this.$store.commit('setSnackbar', {timeout: 6000, text: response.data.message, value: true, color: response.data.status})
					if(response.data.status == 'success') {
						this.$store.dispatch('USER_REQUEST')
					}
					this.loading2FA = false
					this.startDisableTwoFactorAuthentication = false
					this.otp = ''
				}).catch(error => {
					this.loading2FA = false
					this.startDisableTwoFactorAuthentication = false
					this.otp = ''
				})
			},

            verifyOTP() {
				this.loadingOTP = true
				this.axios.post('users-verify2fa', {otp: this.otp}).then((response) => {
					this.$store.commit('setSnackbar', {timeout: 6000, text: response.data.message, value: true, color: response.data.status})
					if(response.data.status == 'success') {
						this.$store.dispatch('USER_REQUEST')
						this.twofaqrcode = ''
					}
					this.otp = ''
					this.loadingOTP = false
				}).catch(error => {
					this.otp = ''
					this.loadingOTP = false
				})
			},

			getCopy() {
				let tempInput = document.createElement('input')
				tempInput.value = this.google2fa_secret
				document.body.appendChild(tempInput)
				tempInput.select()
				document.execCommand('copy')
				document.body.removeChild(tempInput)
				this.$store.commit('setSnackbar', {timeout: 6000, text: 'Copiato negli appunti!', value: true, color: 'success'})
			},
        },

    }
</script>